import { StyleSheet, Platform } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

import cardShadow from '../../Common/Styles/cardShadow';
import { getWindowDimensions } from '../Utils/Helpers';

const paddingBottom = Platform.select({
  ios: 106,
  android: 130,
});

export default StyleSheet.create({
  containerStyle: (withTray, keyboardHeight) => ({
    flex: 1,
    paddingHorizontal: 16,
    paddingBottom: keyboardHeight || (withTray ? paddingBottom : 16),
  }),
  titleTextStyle: {
    ...Fonts.type.bold,
    fontSize: 25,
    lineHeight: 31.2,
    marginBottom: 16.7,
  },
  licenceUsageStyle: {
    ...Platform.select({
      ios: { marginTop: getWindowDimensions.height < 800 ? 12 : 25 },
      android: { marginTop: 16 },
    }),
  },
  yourLicencesStyle: withLicenceUsage => ({
    marginTop: withLicenceUsage || Platform.OS === 'ios' ? 24 : 16,
  }),
  descriptionTextStyle: {
    fontSize: 16,
    color: Colors.dark_grey,
    marginBottom: 16.7,
  },
  pmDescriptionTextStyle: {
    fontSize: 16.6,
    color: Colors.light_grey,
    marginBottom: 16.3,
  },
  pmCardBodyContainer: {
    flexDirection: 'row',
  },
  cardTopTextStyle: {
    fontSize: 18.8,
    lineHeight: 25.7,
    color: Colors.blackTwo,
  },
  divider: theme => ({
    height: 1.5,
    width: '100%',
    backgroundColor: theme.colors.borderColorThree,
  }),
  dividerContainer: {
    paddingBottom: 25,
    paddingTop: 14,
  },
  cardStyle: {
    marginHorizontal: 0,
    marginBottom: 16.5,
    ...cardShadow,
  },
  cardPadding: {
    paddingVertical: 20,
  },
  cardLicencesCountTextStyle: {
    fontSize: 14,
    marginTop: 15,
    marginBottom: 13,
  },
  cardLicencesPricePerUserTextStyle: {
    fontSize: 18,
    marginTop: 8,
  },
  profileManagementCardTextStyle: {
    fontSize: 18.7,
    color: Colors.blackTwo,
    lineHeight: 25,
  },

  usageContainerStyle: theme => ({
    paddingTop: 13,
    paddingBottom: -13,
    paddingHorizontal: 16,
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6.2,
    ...cardShadow,
  }),
  filterBarStyle: {
    marginHorizontal: -16,
  },
  usageValuesTextStyle: {
    color: Colors.dark_grey,
  },
  errorIconStyle: {
    marginTop: 64,
  },
  searchStyle: {
    marginBottom: 24,
  },
  emptyScenarioTextStyle: {
    lineHeight: 20,
    fontSize: 16.7,
    color: Colors.dark_grey,
    marginTop: 10,
    paddingHorizontal: 16,
  },
  emptyScenarioTextContainer: {
    flex: 1,
  },
  emptyLicencesContainer: {
    alignItems: 'center',
    marginTop: 25,
  },
  emptyLicencesImage: {
    marginVertical: 10,
  },
  emptyCaseTitle: {
    fontSize: 20,
    lineHeight: 29.2,
    ...Fonts.type.bold,
  },
  emptyCaseSubtitle: {
    fontSize: 16,
    lineHeight: 22.9,
    paddingVertical: 4,
  },
  usageIconViewStyle: {
    marginTop: 5,
    width: 36,
    height: 36,
    justifyContent: 'center',
    alignItems: 'center',
  },
  leftIconStyle: {
    marginBottom: 40,
  },
  rightIconStyle: {
    marginBottom: 32,
  },
});
